export default [{  // 我的账户
    path: 'my_account',
    name: 'm_account',
    component: () => import('@/pages/account/my_account')
}, {  // 结算记录
    path: 'settlement_record',
    name: 'm_settlement',
    component: () => import('@/pages/account/settlement_record')
}, {  // 资金流水
    path: 'account_record',
    name: 'm_account_record',
    component: () => import('@/pages/account/account_record')
}, {  // 资金提现
    path: 'account_extract',
    name: 'm_account_extract',
	props: route => route.query,
    component: () => import('@/pages/account/account_extract')
}];